<template>
  <translations-tabs>
    <template #default="{language}">
      <VWidget
        :title="$t('Properties')"
      >
        <div slot="widget-header-action">
          <v-btn
            :disabled="language && !language.default"
            flat
            class="text--secondary text-capitalize"
            @click="add"
          >
            {{ $t('Add Property') }}
          </v-btn>
        </div>
        <div slot="widget-content">
          <translatable-collection
            v-model="product"
            :language="language"
            :item-component="PropComponent"
            :creating="creating"
            field-name="properties"
            no-items-text="No Properties"
            @created="creating = false"
          />
        </div>
      </VWidget>
    </template>
  </translations-tabs>
</template>

<script>
import TranslationsTabs from '@/components/widgets/TranslationsTabs'
import ProductProperty from '@/modules/Products/components/ProductProperty'
import Translatable from '@/components/widgets/Translatable'
import TranslatableCollection from '@/components/widgets/TranslatableCollection'

export default {
  name: 'ProductSingleProperties',
  components: { TranslatableCollection, Translatable, ProductProperty, TranslationsTabs },
  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      PropComponent: ProductProperty,
      creating: false
    }
  },

  methods: {
    add () {
      if (this.product.properties === null) {
        this.product.properties = []
      }

      this.creating = true
    }
  }
}
</script>
